/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListUniversitiesQueryResponse,
  ListUniversitiesQueryParams,
} from '../types/ListUniversities'

function getListUniversitiesUrl() {
  const res = { method: 'GET', url: `/api/v1/universities/` as const }
  return res
}

/**
 * @summary List universities
 * {@link /api/v1/universities/}
 */
export async function listUniversities(
  params?: ListUniversitiesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListUniversitiesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListUniversitiesUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
